(function () {
  "use strict";

  var e = {
    175: function _(e, t, i) {
      var r = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Transaction = t.Block = void 0;
      var n = r(i(20));
      t.Block = n.default;
      var m = r(i(651));
      t.Transaction = m.default;
    },
    20: function _(e) {
      e.exports = JSON.parse('{"$id":"https://dev.liquality.com/schema/block.json","title":"Block","description":"Blockchain block","type":"object","required":["number","hash","timestamp","size"],"properties":{"hash":{"type":"string","title":"Hash"},"number":{"type":"number","title":"Number","minimum":0},"timestamp":{"type":"number","title":"Timestamp","minimum":0},"difficulty":{"type":"number","title":"Difficulty","minLength":1},"size":{"type":"number","title":"Size","minimum":0},"parentHash":{"type":"string","title":"Parent Hash"},"nonce":{"type":"number","title":"Nonce","minimum":0},"_raw":{"type":"object"}}}');
    },
    651: function _(e) {
      e.exports = JSON.parse('{"$id":"https://dev.liquality.com/schema/transaction.json","title":"Transaction","description":"Blockchain transaction","type":"object","required":["hash","value"],"properties":{"blockHash":{"type":"string","title":"Block Hash"},"blockNumber":{"type":"number","title":"Block Number","minimum":0},"hash":{"type":"string","title":"Transaction Hash"},"value":{"type":"number","title":"Value","minimum":0},"confirmations":{"type":"number","title":"Confirmations","minimum":0},"feePrice":{"type":"number","title":"Fee Price","minimum":0},"fee":{"type":"number","title":"Fee","minimum":0},"_raw":{"type":"object"}}}');
    }
  },
      t = {},
      i = function i(r) {
    var n = t[r];
    if (void 0 !== n) return n.exports;
    var m = t[r] = {
      exports: {}
    };
    return e[r].call(m.exports, m, m.exports, i), m.exports;
  }(175);

  module.exports = i;
})();